import React from 'react';
import FoodicsCallback from './FoodicsIntegration';

/**
 * FoodicsRedirect Component
 * Handles OAuth callback redirect from Foodics
 * Route: /redirect-foodics
 */
const FoodicsRedirect = () => {
    return <FoodicsCallback />;
};

export default FoodicsRedirect;